import { useEffect, useState } from "react";
import { _AdquisitionContract, _AdquisitionItem, _Project, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../theme/Component/BasicPage"
import { SelectProject } from "../cellEditor/BudgetAccountantOperation/SelectProject";
import { PrintJson } from "../../theme/Component/PrintJson";
import { CardTaps } from "../../theme/Component/CardTaps";
import { AdquisitionProjectLines } from "./AdquisitionProjectLines";
import { ResumeContract } from "../../contract/etapa-contrato/contrac/ResumeContract";
import { _ProjectSchedule } from "../../../core/services/dataBean/EntityCatalogVdos";


export const ProjectResume = () => {

    const _project = useDataBean(_Project);
    const _items = useDataBean(_AdquisitionItem);
    const _schedule = useDataBean(_ProjectSchedule);
    const _contract = useDataBean(_AdquisitionContract);
    const [project, setProject] = useState<any>({});
    const [plan, setPlan] = useState<any>([]);
    const [contract, setContract] = useState<any>([]);
    const [activity, setActivity] = useState<any>([]);
    const [tap, setTap] = useState<any>([]);
    const [indexTap, setIndexTap] = useState(0);

    let taps = [
        { id: 0, name: 'Linea PAA', disable: false },
        { id: 1, name: 'Contratos', disable: false },
        { id: 2, name: 'Actividades', disable: false }
    ];


    useEffect(() => {
        if (project.IDProject) {
            getLieasPAA();
            getContractos();
            getActividades();

        }
    }, [project])

    const getLieasPAA = () => {
        let filter = {
            IDProject: project.IDProject
        }
        _items.instance.getAdquisitionItemByProps(1, 10000, filter).then(
            (resp: any) => {
                setPlan(resp.List);
            }
        )
    }
    const getContractos = () => {
        let filter = {
            IDProject: project.IDProject
        }
        _contract.instance.getResumenPayment(_single.getCurrenYear(), filter, null).then(
            (resp: any) => {
                setContract(resp);
            }
        )
    }
    const getActividades = () => {
        let filter = {
            IDProject: project.IDProject,
            State: 1
        }
        _schedule.instance.getProjectScheduleRender(1, 10000, filter).then(
            (resp: any) => {
                setActivity(resp.List);
            }
        )
    }

    return (
        <BasicPage titulo="Resumen Proyectos">
            <div className="row">

                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-4">
                            <SelectProject idSelector={project?.IDProject} onChange={(e) => { setProject(e ?? {}) }} label="Proyecto" returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <label>Nombre Proyecto</label>
                            <input type="text" name="pro" className="form-control" value={project.Name} readOnly />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="text" className="form-control" value={project.Description}></textarea>
                        </div>
                    </div>
                    {/* <PrintJson json={project} /> */}
                </div>
            </div>
            {project.IDProject &&
                <div className="row mt-4">
                    <hr />
                    <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                        <div className="row">
                            {indexTap === 0 &&
                                <div className="col-md-12">
                                    <ul className="list-group ">
                                        {plan.map((item: any, index: number) => {
                                            return (
                                                <li className="list-group-item m-2">
                                                    <p>
                                                        <h6><strong>{item.DataBeanProperties.Description} </strong> </h6>
                                                        <hr />
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <strong>Presupuesto</strong> ${_single.formatMoney(item.DataBeanProperties.PFValue)} <br />
                                                                    <strong>Valor Estimado</strong> ${_single.formatMoney(item.DataBeanProperties.TotalValue)}
                                                                </p>
                                                            </div>                                                            
                                                            <div className="col-md-12">
                                                                <p><strong>Rubros </strong>
                                                                    {item.DataBeanProperties.IDLnBudgetIDNameList}
                                                                    <br />
                                                                    {item.DataBeanProperties.PreparationStateName}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </p>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            }
                            {indexTap === 1 &&
                                <div className="col-md-12">
                                    <ul className="list-group ">
                                        {contract.map((item: any, index: number) => {
                                            return (
                                                <li className="list-group-item m-2">
                                                    <p>
                                                        <h6><strong>{item.DataBeanProperties.Description} <small className="text-rigth">({item.DataBeanProperties.InternalCode})</small></strong> </h6>
                                                        <hr />
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <strong>Proveedor </strong>
                                                                    {item.DataBeanProperties.EntityName} / {item.DataBeanProperties.Nit} <br />
                                                                    <strong>Valor Contrato </strong>
                                                                    ${_single.formatMoney(item.DataBeanProperties.ContractAmount)} <br />
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <div className="row">
                                                                        <div className="col">
                                                                            <strong>CDP</strong><br />${_single.formatMoney(item.DataBeanProperties.CDPValue)}
                                                                        </div>
                                                                        <div className="col">
                                                                            <strong>RP</strong><br />${_single.formatMoney(item.DataBeanProperties.RPValue)}
                                                                        </div>
                                                                        <div className="col">
                                                                            <strong>OB</strong><br />${_single.formatMoney(item.DataBeanProperties.OBValue)}
                                                                        </div>
                                                                        <div className="col">
                                                                            <strong>CE</strong><br />${_single.formatMoney(item.DataBeanProperties.CEValue)}
                                                                        </div>
                                                                    </div>
                                                                </p>
                                                            </div>

                                                        </div>
                                                    </p>
                                                </li>
                                            )
                                        })}
                                    </ul>

                                </div>
                            }
                            {indexTap === 2 &&
                                <div className="col-md-12">
                                    <ul className="list-group ">
                                        {activity.map((item: any, index: number) => {
                                            return (
                                                <li className="list-group-item m-2">
                                                    <p>
                                                        <h6><strong dangerouslySetInnerHTML={{ __html: item.DataBeanProperties.Objective }}></strong>  </h6>
                                                        <hr />
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p >
                                                                    <span dangerouslySetInnerHTML={{ __html: item.DataBeanProperties.TaskDescription }}></span>
                                                                </p>
                                                                <p>
                                                                    <strong>Estado </strong>
                                                                    {item.DataBeanProperties.StateName} <br />
                                                                    <strong>Fecha Inicial </strong>
                                                                    {item.DataBeanProperties.FromDate}  <strong> Dias vencido {item.DataBeanProperties.Days}</strong><br />
                                                                    <strong>Fecha Final </strong>
                                                                    {item.DataBeanProperties.UptoDate} <br />
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <strong>Responsable : </strong>
                                                                    {item.DataBeanProperties.IDAccountResponsibleName}<br />
                                                                    <strong>Area : </strong>
                                                                    {item.DataBeanProperties.JSonCode} {item.DataBeanProperties.NameArea}<br />
                                                                </p>

                                                            </div>


                                                        </div>
                                                    </p>
                                                </li>
                                            )
                                        })}
                                    </ul>

                                   
                                </div>
                            }
                             {/* <PrintJson json={plan} /> */}
                        </div>
                    </CardTaps>
                </div>
            }
        </BasicPage>
    )
}